import type { PricingCardType } from "../../types";

export const triggerClasses =
	"cursor-pointer data-[state=active]:bg-gold data-[state=active]:text-black text-white h-[90%]";

export const pricingList: Partial<PricingCardType>[] = [
	{
		id: 1,
		monthlyPrice: 0,
		yearlyPrice: 0,
		plan: "bronze",
		options: [
			"Real-Time US Stock / ETF Prices",
			"Stock Quote / Ratio Analysis",
			"Advanced Chart",
			"Sector Rotation",
			"Earnings Calendar",
			"Stock Scanners",
			"Stock Screener",
			"Company News",
			"Company Financials",
			"Chat Room (Bronze)",
			"1 Savable Monitor",
			"1 Savable Screener",
		],
		disabled: false,
	},
	{
		id: 2,
		monthlyPrice: 9.99,
		yearlyPrice: 83.88,
		plan: "silver",
		options: [
			"Bronze Plan Features",
			"Advanced Quote",
			"Additional Chart Indicators",
			"Custom News Panel",
			"Company Financials",
			"Silver User Chat Room",
			"3 Savable Monitors",
			"3 Savable Screeners",
			"1 Custom Dashboard",
		],
		disabled: false,
		additionalInfo: "Save 30% and pay $6.99 on a yearly plan",
	},
	{
		id: 3,
		monthlyPrice: 49.99,
		yearlyPrice: 419.88,
		plan: "gold",
		options: [
			"Silver Plan Features",
			"Company Earnings Matrix",
			"Earnings Revision Scores",
			"Stock Drift (PEAD)",
			"Dark Shorts",
			"Stock Scorer",
			"Full Chart Package",
			"AI Analyst",
			"Gold User Chat Room",
			"Unlimited Monitors",
			"Unlimited Screeners",
			"Unlimited Dashboards",
		],
		disabled: false,
		additionalInfo: "Save 30% and pay $34.99 on a yearly plan",
	},
	{
		id: 4,
		monthlyPrice: 125,
		yearlyPrice: 1500,
		plan: "platinum",
		options: [
			"Gold Plan Features",
			"Advanced Strategy",
			"Backtesting Module",
			"Platinum User Chat",
		],
		disabled: true,
	},
];
